<script setup lang="ts">
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()


const comment = ref<string>("")
const user = computed(() => ({
  profileImage: store.getters['user/userProfile'].picture
}))
const isEditingComment = ref<boolean>(false)
const isSendingComment = ref<boolean>(false)
const commentArea = ref(null)
const commentMinHeight = ref<number>(40); // Set an initial min-height value

const props = defineProps(["placeholder", "iconSize", "minimalButton"])
const emits = defineEmits(["commentSubmitted"])


const handleFocusOut = () => {
    if(!isSendingComment.value){
        const comment = commentArea.value?.textContent
        commentArea.value.textContent = comment
        isEditingComment.value = false
    }

    if(commentArea.value.textContent === ""){
        commentArea.value.textContent = props.placeholder
        commentMinHeight.value = 40
    }
}

const iconSize = computed(() => {
    if(props.iconSize === "mini"){
        return "rounded-image-mini"
    } else if(props.iconSize === "smaller"){
        return "rounded-image-smaller"
    } else if (props.iconSize === 'none'){
        return "!hidden"
    }
    else {
        return "rounded-image"
    }
})

const handleClick = () => {
    const comment = commentArea.value
    if(comment.innerText === props.placeholder){
        comment.innerText = ""
    }
    isEditingComment.value = true
}

const submitCommentAndResetField = async () => {
    isSendingComment.value = true
    const commentAreaValue =  commentArea.value.textContent
    if(commentAreaValue.length > 3 && commentAreaValue !== props.placeholder){
        comment.value = commentAreaValue
       
        emits("commentSubmitted", comment.value)

        isEditingComment.value = false
        commentArea.value.textContent = props.placeholder
        commentMinHeight.value = 40

    } else {
        alert("Yorumunuz en az 3 karakterden oluşmalıdır.")
    }
}

const updateCommentHeight = () => {
  if (commentArea.value) {
    const contentHeight = commentArea.value.scrollHeight;
    commentMinHeight.value = Math.max(contentHeight, 40); // Set a minimum height
  }
};

const hardCancelComment = () => {
    commentArea.value.textContent = props.placeholder
    isEditingComment.value = false
    commentMinHeight.value = 40

}


</script>

<template>
    <div class="reusable-comment flex flex-col">
        <div class="flex items-start">
            <img :class="iconSize" class="rounded-image-smaller mr-6" referrerpolicy="no-referrer" :src="user.profileImage" alt="Profil Resmi">
            <div 
            class="comment-field-area"
            ref="commentArea"
            @click="handleClick"
            @blur="handleFocusOut"
            @input="updateCommentHeight"
            @keyup.esc="hardCancelComment"
            tabindex="0" 
            :style="{ minHeight: commentMinHeight + 'px' }"
            :contenteditable="isEditingComment">
                {{ props.placeholder }}
            </div>
        </div>

        <transition
        type="animation"
        enter-active-class="animate__animated animate__fadeInDown"
        leave-active-class="animate__animated animate__fadeOutUp animate__fast"
        mode="out-in"
        >

        <button v-if="isEditingComment && minimalButton" tabindex="-1" class="ac-subtle-button mt-4 self-start" @click="submitCommentAndResetField">
            Gönder </button>
        </transition>

        <transition
        type="animation"
        enter-active-class="animate__animated animate__fadeInDown"
        leave-active-class="animate__animated animate__fadeOutUp animate__fast"
        mode="out-in"
        >

            <button v-if="isEditingComment && !minimalButton" tabindex="-1" class="ac-primary-button ml-12 mt-8 self-start" @click="submitCommentAndResetField">
            Gönder
            </button>

        </transition>


    </div>
</template>

<style>



.comment-field-area{
    width: 100%;
    padding: .8rem .5rem;
    border: 1px solid var(--accent-gray-subtle);
    transition: all .2s;
    height: 4rem;
    box-shadow: var(--main-box-shadow);
    font-family: var(--gidole);
    border-radius: 6px;
    outline: none;
    font-size: 1.5rem;
    line-height: 1.5;

}

.reusable-comment .ac-primary-button {
    margin-left: 6rem;
    font-size: 1.4rem;
}

.comment-area:focus{
    border: 1px solid var(--accent-gray);
    box-shadow: var(--hb-box-shadow);
}



</style>